__webpack_require__.p = "https://cdn-staging.just-eat.co.il/justeat-il-spa-server-rc-dev/";